const UrlsFileName = (props) => {
  const fileName = props?.row?.original?.file_name || "-";

  return <span title={fileName}>{fileName}</span>;
};

export default UrlsFileName;
